// extracted by mini-css-extract-plugin
module.exports = {"footer":"OhFooter_footer__3IQ6I"};